import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
  AiFillMail,
  AiOutlineMedium,
  AiOutlineMediumWorkmark
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { FaRegHandshake } from "react-icons/fa";
import { TiSocialGithub } from "react-icons/ti";
import { BsMedium} from "react-icons/bs";
import { FaPencilAlt} from "react-icons/fa";
import { IoMdShare } from "react-icons/io";



function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              About Me
            </h1>
            <p className="home-about-body">
            I'm a Research Assistant in the GeoMatics Research Group at the University of Colombo School of Computing. My recent research endeavours have centered around Geographic Information Systems (GIS). I'm committed to collaborating with a team to achieve research goals and make valuable contributions to the field.
            </p>
            <hr/>
            <p align="left">Have a look at my projects on &nbsp;
            
            <a
                  href="https://github.com/vinuri-s"
                  target="_blank"
                  rel="noreferrer"
                  style={{ textDecoration: 'none' }}
                >
                  GitHub<TiSocialGithub/>
                </a>&nbsp;
                
        |&nbsp;Read my articles on &nbsp;
            <a
                  href="https://vinuri.medium.com"
                  target="_blank"
                  rel="noreferrer"
                  style={{ textDecoration: 'none' }}

                >
                 Medium <FaPencilAlt/>
                </a> </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
            <h5 color="blue">Let's Get Connected <IoMdShare /></h5>
            <ul className="home-about-social-links">              
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/piyathilakev/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn/>
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://facebook.com/vinuri.piyathilake"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                   <FaFacebook/>
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/_vinuri_"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaTwitter />
                </a>
              </li>
              {/*<li className="social-icons">
                <a
                  href="https://twitter.com/vinuri"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>*/}
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/vinuri_s/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
           
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
